import { FC } from 'react';
import { Button } from '../../atoms';
import styles from './LandscapeProjectsTemplate.module.css';
import { Container } from 'react-bootstrap';
import BaseTemplate from '../../templates/BaseTemplate';
import { useNavigate, useParams } from 'react-router-dom';
import LandscapeBaseEditTemplate from '../../../templates/LandscapeBaseEditTemplate';
import { LandscapeProjectsOrganism } from '../../organisms';
import { ProjectResponseDto } from '../../../store/landscapeAPI/project/dto/response/project-response.dto';

export interface LandscapeProjectsTemplateProps {
  projects: ProjectResponseDto[];
  handleDeleteProject: (id: string) => void;
}

const LandscapeProjectsTemplate: FC<LandscapeProjectsTemplateProps> = ({
  projects,
  handleDeleteProject,
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const onAddProjectClick = () => {
    navigate(
      `/landscapes/edit/${id}/projects/add-project/new-project/basic-information`
    );
  };

  return (
    <BaseTemplate>
      <Container>
        <LandscapeBaseEditTemplate>
          <div className={styles.buttonOnly}>
            <Button
              variant="dark"
              className={styles.buttonWithIcon}
              onClick={onAddProjectClick}
            >
              Add Projects
            </Button>
          </div>
          <LandscapeProjectsOrganism
            content={projects}
            handleDeleteProject={handleDeleteProject}
          />
        </LandscapeBaseEditTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeProjectsTemplate;
